var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "instagram",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.778,
    height: 19.778,
    viewBox: "0 0 19.778 19.778",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5529",
    "data-name": "Caminho 5529",
    d: "M13.886,0H5.892A5.9,5.9,0,0,0,0,5.892v7.994a5.9,5.9,0,0,0,5.892,5.892h7.994a5.9,5.9,0,0,0,5.892-5.892V5.892A5.9,5.9,0,0,0,13.886,0Zm3.9,13.886a3.9,3.9,0,0,1-3.9,3.9H5.892a3.9,3.9,0,0,1-3.9-3.9V5.892a3.9,3.9,0,0,1,3.9-3.9h7.994a3.9,3.9,0,0,1,3.9,3.9v7.994Z",
    transform: "translate(0 0)",
    fill: "#d8dfe8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_5530",
    "data-name": "Caminho 5530",
    d: "M138.115,133a5.115,5.115,0,1,0,5.115,5.115A5.121,5.121,0,0,0,138.115,133Zm0,8.241a3.126,3.126,0,1,1,3.126-3.126A3.126,3.126,0,0,1,138.115,141.241Z",
    transform: "translate(-128.226 -128.226)",
    fill: "#d8dfe8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_11",
    "data-name": "Elipse 11",
    cx: 1.226,
    cy: 1.226,
    r: 1.226,
    transform: "translate(13.789 3.586)",
    fill: "#d8dfe8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.71ccaf325b467f183887386b4a962b97.svg";
export { ForwardRef as ReactComponent };